import { render, staticRenderFns } from "./topContent.vue?vue&type=template&id=07b97b8a&scoped=true&"
import script from "./topContent.vue?vue&type=script&lang=js&"
export * from "./topContent.vue?vue&type=script&lang=js&"
import style0 from "./topContent.vue?vue&type=style&index=0&id=07b97b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b97b8a",
  null
  
)

export default component.exports